var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ts-types"},[_c('ul',{staticClass:"ts-types__list"},_vm._l((_vm.values),function(item){return _c('li',{key:item.id,class:_vm.getClassName(item.id),on:{"click":function($event){return _vm.changeType(item.id)}}},[_c('r-text',[_vm._v(" "+_vm._s(item.name)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }